export const deviceOptionsDataKeys = {
  LCU_TYPE: 'LCU.TYPE',
  ADMIN_RFID_CARD: 'LcuSettings.adminRFIDCard',
  LCU_SERVICE_TAG: 'LcuSettings.serviceTag',
  RX_SERIAL_PORT_1: 'LcuSettings.rxSerial1Configuration',
  RX_SERIAL_PORT_2: 'LcuSettings.rxSerial2Configuration',
  RX_SERIAL_ACTIVE_PORT: 'LcuSettings.rxComPort'
};
